import React from 'react';

/** Tela cheia de "carregando", no desenho do Finance (.panel-loading): fundo claro e o átomo. */
export default function TelaCarregando({ texto = 'Carregando...' }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-100 to-slate-50 flex items-center justify-center">
      <div className="text-center">
        <img src="/integrai-marca.png" alt="" className="w-24 h-auto mx-auto mb-5" />
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-slate-500 text-sm">{texto}</p>
      </div>
    </div>
  );
}
